import {AssignmentInfo, UserInfo} from 'interfaces';

export enum ConversationStatus {
    Chatbot = 'chatbot',
    Calling = 'calling',
    InSession = 'in_session',
}

export type ConversationParticipant = {
    id: string;
    eid: number;
    role: string;
    name: string;
    joinedAt: string;
    leftAt?: string;
    active: boolean;
};

export type ConversationMessage = {
    id: string;
    participantId: string;
    content: string;
    contentType: string;
    date: string;
    data?: Record<string, unknown>;
};

export type ConversationChannelIntegrationData = {
    phone?: string;
    phoneNumberId?: string;
    chatId?: string;
    login?: string;
};

export type ConversationChannel = {
    id: string;
    conversationId: string;
    type: string;
    status: string;
    startDate: string;
    endDate?: string;
    participants: ConversationParticipant[];
    messages: ConversationMessage[];
    messageCount?: number;
    integrationData?: ConversationChannelIntegrationData;
};

export type ConversationChannelRef = {
    channelId: string;
    type: string;
    status: string;
};

export type ConversationClient = {
    userInfo: UserInfo;
    clientInfo?: Record<string, unknown>;
    device?: Record<string, unknown>;
};

export type Conversation = {
    id: string;
    assignment: AssignmentInfo;
    status: string;
    client: ConversationClient;
    channels?: ConversationChannelRef[];
    meta?: Record<string, unknown>;
    linkedSessionIds?: string[];
    lastActivityAt: string;
    createdAt: string;
    updatedAt?: string;
    archived?: boolean;
    archivedAt?: string;
    archiveReason?: string;
};
